<template>
  <div class="qa-main">
		<div class="qa">
		    <div class="qa-section" v-for="section in sections" :key="section.title">
	        <div class="title">{{ section.title }}</div>
          <template v-for="item in section.items">
            <p class="ask" :key="item.question">{{ item.question }}</p>
            <p class="answer" :key="item.answer">{{ item.answer }}</p>
          </template>
	      </div>
		    
		</div>
	  </div>
</template>

<script>

export default {
  data () {
    return {
      sections: [
        {
          title: '关于新人赛',
          items: [
            {
              question: 'Q:我怎样报名参加竞赛呢？',
              answer: 'A：在本网站(http://www.archirookies.com/)上注册，登录并按提示流程提交作品即可。'
            },
            {
              question: 'Q：我是一个规划系的学生，我可以参加比赛吗？',
              answer: 'A：规划类、景观类专业也欢迎参加！不过要注意比赛条件：投稿作业是本教学年度（2025-2026学年）的“建筑设计作业”。'
            },
            {
              question: 'Q：我是一名四年级的学生，我可以投稿三年级时期的作品吗？',
              answer: 'A：抱歉，不可以。新人赛仅接收本教学年度（2025-2026学年）的建筑设计作品，原则上只有本科一至三年级可以报名。'
            },
            {
              question: 'Q：我在做课程设计的时候是一个人，但是在之后更改课程设计和成图的时候是多人参与的，这种情况可算作个人成果么？',
              answer: 'A：按该课程设计的任务书要求，规定是一个人完成的话，则算作个人成果。'
            },
            {
              question: 'Q：我想拿来参加比赛的设计基于学校历史和学校建筑空间的研究，学校历史或现状可能会在图里显示，这怎么办呀？',
              answer: 'A：这种情况的话图纸中只能写“某学校”。如果基地在学校里，场地周边的用房，道路都需要自行处理一下。只要不出现具体名称，图上出现建筑物的形象也没关系。'
            },
            {
              question: 'Q：图纸中可以出现场地的实景照片吗？',
              answer: 'A：可以的，不出现选手、老师、学校信息即可。出现校园内的建筑形象是可以的，但是需要对出现的名称做处理。'
            },
            {
              question: 'Q：能不能拿桥梁设计的作业参赛呢？',
              answer: 'A：新人赛欢迎各种作业的投稿，评委团队自有判断。'
            },
            {
              question: 'Q：我要参加比赛的话是重新做一个设计还是修改自己的课程作业呢？',
              answer: 'A：修改课程作业为宜，这也是新人赛的初衷。'
            }
          ]
        },
        {
          title: '关于图纸',
          items: [
            {
              question: 'Q：我想用纯手绘的图纸参加比赛可以吗？',
              answer: 'A：完全可以。只需要把图纸扫描之后上传即可，但文件内容要与我们的具体要求相符。'
            },
            {
              question: 'Q：赛道一海选要求提交的四页图纸是指什么格式的呢，有大小的要求吗？',
              answer: 'A：图纸格式的要求是jpeg、png格式都可以，没有版面大小的要求，但是文件大小要小于2MB；并小于4000×4000（像素）。（推荐手绘图纸可以排4张A2版面的图纸，这与最终决赛的图纸格式相对应，便于修改）'
            },
            {
              question: 'Q：封面与图纸大小不一样？',
              answer: 'A：是的，封面规定的尺寸是800×600（像素）的横版。'
            },
            {
              question: 'Q：我没有一次提交所有的图，是不是就没法保存已经提交的了？',
              answer: 'A：已经提交的图纸会保存，但是下次提交会将上一次提交的图纸覆盖，所以务必每次上传都要上传完整的图纸。'
            },
            {
              question: 'Q：字体字数有要求吗？',
              answer: 'A：没有要求。'
            },
            {
              question: 'Q：图纸中的文字说明是否有必要用英文？',
              answer: 'A：没有必要的。'
            },
            {
              question: 'Q：封面的具体要求和作用可以再明确一下吗？',
              answer: 'A：评审评阅界面首先看到的是封面，点击进入后会看到任务书与图纸，所以在设计封面时可以放上效果图或设计一个LOGO，可以考虑封面与图纸风格的统一，为评审留下一个较好的印象哦~但要注意的是封面不能出现个人信息！封面的尺寸是800×600像素，请大家认真阅读公众号推送中所提到的要求。'
            },
            {
              question: 'Q：我的四张图纸有明确的版面要求吗？',
              answer: 'A：没有。即无论是A1、A2、A3、A4，或者此比例之外皆可。但进入100强之后会有明确的图纸版面规范'
            },
            {
              question: 'Q：我的四张图纸尺寸不同可以吗？',
              answer: 'A：图纸和图纸之间不要求大小一致，图纸和封面也不要求大小一致，但为了提高评委教师审阅体验，我们推荐四张大小一致的图纸。'
            }
          ]
        },
        {
          title: '关于任务书',
          items: [
            {
              question: 'Q：请问任务书有统一的格式吗？',
              answer: 'A：没有统一格式，依各学校具体情况。'
            },
            {
              question: 'Q：请问任务书一页是交图片格式的还是word？',
              answer: 'A：jpeg或者png格式。'
            },
            {
              question: 'Q：我的任务书有地形图的话要一起放上去吗？',
              answer: 'A：根据个人情况，可以放进去。'
            },
            {
              question: 'Q：任务书可以直接使用学校统一的原版任务书吗？是否需要对内容进行修改？',
              answer: 'A：依个人情况而定，任务书需体现真实的课程要求相关信息，但不得包含学校、个人、指导老师信息。'
            },
            {
              question: 'Q：任务书只能一页吗？作业任务书原本有好多页怎么办？',
              answer: 'A：是的，只能上传一页任务书。所以请大家将多页任务书排版整理成一页上传。任务书的尺寸要求是4000×4000像素。'
            }
          ]
        }
      ]
    }
  },
  components: {
  }
}
</script>

<style scoped>
.qa{
    padding: 50px calc((100% - 1024px) / 2);
}
.ask{
    font-weight: bold;
    margin-bottom:10px;
    margin-top:20px;
}
.answer{
}
.qa-section{
    margin-bottom: 40px;
}
.title{
    color: #25335e;
    display: inline-block;
    padding: 7px 0;
    font-size: 17px;
    font-weight: bold;
    border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// Qa.vue?451a63e2